module.exports = __webpack_public_path__ + "media/images/icons/icon-hands-2266744604423719f258b0a00e7de325.svg";